var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_vm._t("default"),_c('svg-icon',{staticClass:"svg-icon--size_s message__close-button",attrs:{"src":"icomoon.svg#icon-cross"},nativeOn:{"click":function($event){return _vm.close($event)}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }